// extracted by mini-css-extract-plugin
module.exports = {"component":"NotFound_component__12QTm","gearsImg":"NotFound_gearsImg__3h30-"};